import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    logined: localStorage.getItem("logined") && localStorage.getItem("logined") === "true",
    // logined: true,
    userInfo: localStorage.getItem("userInfo") ? JSON.parse(localStorage.getItem("userInfo")) : {}
  },
  mutations: {
    setLogined (state, logined) {
      state.logined = logined;
    },
    setUserInfo (state, userInfo) {
      state.userInfo = userInfo;
    }
  },
  actions: {},
  modules: {},
});
